import { render, staticRenderFns } from "./OpportunityListRow.vue?vue&type=template&id=198f4a52&scoped=true&"
import script from "./OpportunityListRow.vue?vue&type=script&lang=js&"
export * from "./OpportunityListRow.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityListRow.vue?vue&type=style&index=0&id=198f4a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198f4a52",
  null
  
)

export default component.exports